import { render } from "./Interpellation.vue?vue&type=template&id=07e6042c&scoped=true"
import script from "./Interpellation.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Interpellation.vue?vue&type=script&charset=utf-8&lang=js"

import "./Interpellation.vue?vue&type=style&index=0&id=07e6042c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e6042c"]])

export default __exports__